import { get, post } from './api';
import type { ScheduleUpdateNotification } from '../types/schedule-updates';

/**
 * List the caller's schedule-update notifications, newest first. Org- and
 * user-scoped server-side.
 *
 * @param unreadOnly when true, the server returns only notifications whose
 *   `readAt` is null. Defaults to false (all notifications).
 */
export async function getScheduleUpdates(
  unreadOnly: boolean = false,
  signal?: AbortSignal
): Promise<ScheduleUpdateNotification[]> {
  return get<ScheduleUpdateNotification[]>(
    `/api/schedule-updates?unreadOnly=${unreadOnly}`,
    { signal }
  );
}

/**
 * Mark a schedule-update notification read (server-authoritative `readAt`).
 * Returns the updated notification with `readAt` populated.
 */
export async function markScheduleUpdateRead(
  id: string,
  signal?: AbortSignal
): Promise<ScheduleUpdateNotification> {
  return post<ScheduleUpdateNotification>(
    `/api/schedule-updates/${id}/read`,
    undefined,
    { signal }
  );
}

/** The server's response to marking every unread notification read. */
export interface MarkAllScheduleUpdatesReadResult {
  /** How many notifications this call transitioned from unread to read. */
  markedReadCount: number;
}

/**
 * Mark every unread schedule-update notification for the caller read
 * (server-authoritative `readAt`). Returns how many were marked.
 */
export async function markAllScheduleUpdatesRead(
  signal?: AbortSignal
): Promise<MarkAllScheduleUpdatesReadResult> {
  return post<MarkAllScheduleUpdatesReadResult>(
    `/api/schedule-updates/read-all`,
    undefined,
    { signal }
  );
}
